import * as Yup from "yup";
import { createFields } from "../helpers/createFields.js";
import { buildValidationSchema } from "../yup/buildValidationSchema.js";
const fields = (currentKeys) => createFields({
  wishesAndExpectations: {
    __type: "custom",
    label: "any",
    validation: Yup.array().of(
      Yup.object().shape({
        key: Yup.string().required(),
        flag: Yup.boolean(),
        score: Yup.number().nullable(),
        required: Yup.boolean()
      }).test("what-is-important-score", "error", function(value) {
        return !(value.key === "what_is_important" && (currentKeys == null ? void 0 : currentKeys.includes("what_is_important")) && !value.score);
      })
    ),
    name: "wishesAndExpectations"
  }
});
const validationSchema = (currentKeys) => buildValidationSchema(fields(currentKeys));
export {
  fields as default,
  validationSchema
};
